import { render } from "./ResearchFellowsDetailsComponent.vue?vue&type=template&id=72b460c6&scoped=true"
import script from "./ResearchFellowsDetailsComponent.vue?vue&type=script&lang=js"
export * from "./ResearchFellowsDetailsComponent.vue?vue&type=script&lang=js"

import "./ResearchFellowsDetailsComponent.vue?vue&type=style&index=0&id=72b460c6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b460c6"]])

export default __exports__